<div
  #svg
  class="svg"
  [removeSVGAttributes]="removeAttributes"
  [inlineSVG]="'/assets/shape.svg'"
></div>
<div class="content">
  <ng-content></ng-content>
</div>
